import React from 'react';
import { FormBuilder } from 'commons-ui';
import { CREATE_FORM_FIELD_CONFIG, CREATE_FORM_LAYOUT_CONFIG, validationSchema } from '../../formConfig';
import useCreate from './useCreate';

const CreateSegment: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useCreate();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={CREATE_FORM_FIELD_CONFIG}
			layoutConfig={CREATE_FORM_LAYOUT_CONFIG}
			buttonLabels={{ discardLabel: 'Back', submitLabel: 'Submit' }}
		/>
	);
};

export default CreateSegment;
